import { useCallback, useEffect, useLayoutEffect, useState } from 'react'

import { confirmAlert } from 'react-confirm-alert'

import { MdEdit, MdClose } from 'react-icons/md'

import { useSelector } from 'react-redux'

import Loading from '../../../components/Loading'

import { Header } from '../../../components/Main'

import List from '../../../components/Main/List'

import { Confirm } from '../../../components/Modal'

import history from '../../../routes/history'

import api from '../../../services/api'

import removerAcentos from '../../../utils/removerAcentos'

function Metodos(props) {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const { path } = props.match

  const { searchTermValue } = useSelector(state => state.search)

  const getPayments = useCallback(async () => {
    const response = await api.get('/payments')

    setData(() => {
      return response.data.filter(element => {
        return removerAcentos(element.titulo.toLowerCase()).includes(
          searchTermValue.toLowerCase()
        )
      })
    })
  }, [searchTermValue])

  const handleClickDelete = useCallback(
    async item => {
      const { id } = item

      await api.delete(`/payments/${id}`)

      const newData = data.filter(data => data.id !== id)

      setData(newData)
    },
    [data]
  )

  const handleDelete = useCallback(
    data => {
      confirmAlert({
        overlayClassName: 'overlay-custom-class-name',
        customUI: function confirmDelete({ onClose }) {
          return (
            <Confirm
              onClose={onClose}
              handleClickDelete={() => handleClickDelete(data)}
            />
          )
        }
      })
    },
    [handleClickDelete]
  )

  useEffect(() => {
    getPayments()
  }, [getPayments])

  useLayoutEffect(() => {
    setTimeout(() => {
      setLoading(false)
    }, 1000)
  }, [])

  if (loading) {
    return <Loading />
  }

  return (
    <>
      <Header title="Métodos de pagamentos" path={`${path}/new`} />
      <List>
        <thead>
          <tr>
            <th>ID</th>
            <th>Titulo</th>
            <th>Método</th>
            <th>Data de Criação</th>
            <th>Opções</th>
          </tr>
        </thead>
        <tbody>
          {data.map(data => (
            <tr key={data.id}>
              <td data-label="ID">
                <div>{data.id}</div>
              </td>
              <td data-label="Titulo">
                <div className="produto_link">{data.titulo}</div>
              </td>
              <td data-label="Método">{data.metodo}</td>
              <td data-label="Data de Criação">
                <div>{data.created_at}</div>
              </td>
              <td data-label="Opções">
                <div className="container_opcoes">
                  <div
                    onClick={() => history.push(`/metodos/edit/${data.id}`)}
                    className="opcoes"
                  >
                    <MdEdit size={21} color="var(--orange)" />
                  </div>
                  <div onClick={() => handleDelete(data)} className="opcoes">
                    <MdClose size={21} color="var(--orange)" />
                  </div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </List>
    </>
  )
}

export default Metodos
